'use strict';

import React from 'react';
import { map } from 'underscore';
import LightboxStore from '../stores/LightboxStore';
import Messages from '../constants/NotificationMessages';
import Notification from '../organisms/Notification';
import NotificationStore from '../stores/NotificationStore';
import ZineStore from '../stores/ZineStore';
import PlayerStore from '../stores/PlayerStore';
import NotificationActionCreators from '../actions/NotificationActionCreators';
import ShareActionCreators from '../actions/ShareActionCreators';
import ZineLink from '../atoms/ZineLink';
import Link from '../atoms/Link';
import Share from '../molecules/Share';
import createStoreMixin from '../mixins/createStoreMixin';
import ServiceTypes from '../constants/ServiceTypes';
import TimeoutTransitionGroup from '../utils/TimeoutTransitionGroup';
import UserActionCreators from '../actions/UserActionCreators';
import AnalyticsSources from '../constants/AnalyticsSources';
import PureRenderMixin from '../mixins/PureRenderMixin';
import UserStore from '../stores/UserStore';
import ClassNameMixin from '../mixins/ClassNameMixin';
import UserLink from '../atoms/UserLink';

const NotificationHost = React.createClass({
  mixins: [createStoreMixin(NotificationStore, PlayerStore, LightboxStore), ClassNameMixin, PureRenderMixin],

  getStateFromStores() {
    return {
      notifications: NotificationStore.getNotifications(),
      isStickyPlayerActive: !!PlayerStore.getStickyMediaId(),
      isInLightbox: LightboxStore.isActive()
    };
  },

  getCSSModifiers() {
    const { isStickyPlayerActive, isInLightbox } = this.state;
    return [
      isStickyPlayerActive && !isInLightbox && 'withStickyPlayer'
    ];
  },

  render() {
    return (
      <TimeoutTransitionGroup className={this.getClassName()}
                              transitionName='Notification'
                              enterTimeout={500}
                              leaveTimeout={500}>
        {map(this.state.notifications, this.renderNotification)}
      </TimeoutTransitionGroup>
    );
  },

  renderNotification(notification) {
    const action = this.getAction(notification);
    const content = this.getContent(notification);

    return (
      <Notification key={'notification' + notification.id + notification.created}
                    content={content}
                    action={action}
                    onCloseClick={this.handleCloseClick.bind(this, notification)} />
    );
  },

  getContent(notification) {
    const promoteStamp = 'Share your work to give recognition it deserves.';
    let zine;
    let user;

    if (notification.zineSlug) {
      zine = ZineStore.get(notification.zineSlug);
    }

    if (notification.userId) {
      user = UserStore.get(notification.userId);
    }

    switch (notification.id) {
    case Messages.UNSUPPORTED_BROWSER:
      return (<span>Stampsy does not support this browser.</span>);
    case Messages.STAMP_SUBMITTED_TO_ZINE:
      return (<span>Submitted to <ZineLink zine={zine} bold />.<br />You may have to wait for approval from the curator.</span>);
    case Messages.STAMP_APPROVED_TO_ZINE:
      return (<span>Added to <ZineLink zine={zine} bold /></span>);
    case Messages.STAMP_DECLINED_FROM_ZINE:
      return (<span>Declined submission to <ZineLink zine={zine} bold /></span>);

    case Messages.STAMP_HAS_BEEN_SAVED:
      return (<span>Your Stamp has been saved. {promoteStamp}</span>);
    case Messages.STAMP_HAS_BEEN_DELETED:
      return (<span>Your Stamp has been deleted</span>);

    case Messages.ZINE_CREATED:
      return (<span>Collection created</span>);
    case Messages.ZINE_SAVED:
      return (<span>Collection saved</span>);
    case Messages.ZINE_DELETED:
      return (<span>Collection deleted</span>);
    case Messages.ZINE_FOLLOWED:
      return (<span>You are now following <ZineLink zine={zine} bold /></span>);

    case Messages.YOU_CAN_CONTRIBUTE_TO_ZINE:
      return (<span>You can now contribute to <ZineLink zine={zine} bold /> collection</span>);

    case Messages.ACCOUNT_CONNECTED:
      return (<span>Account connected</span>);

    case Messages.INVITE_SENT:
      return (<span>Invite sent</span>);
    case Messages.INVITE_SENT_ERROR:
      return (<span>Failed to send an invite</span>);

    case Messages.PASSWORD_RESET_CHECK_EMAIL:
      return (<span>To change password, follow the instructions sent to your email.</span>);
    case Messages.PASSWORD_RESET_DONE:
      return (<span>Your password has been changed</span>);

    case Messages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
      return (<span>You need to confirm your email. Verification message has been sent to <b>{notification.email}</b>.</span>);
    case Messages.USER_NEW_EMAIL_NEEDS_CONFIRMATION:
      return (<span>You need to confirm your new email. Verification message has been sent to <b>{notification.email}</b>.</span>);
    case Messages.USER_EMAIL_RESENT:
      return (<span>Message has been resent.</span>);
    case Messages.USER_EMAIL_CHANGE_CANCELED:
      return (<span>Email change has been canceled.</span>);
    case Messages.EMAIL_CONFIRMED:
      return (<span>You have successfully verified your email <b>{notification.email}</b>. Thank you!</span>);
    case Messages.USER_FOLLOWED:
      return (<span>You are now following <UserLink user={user} bold /></span>);

    case Messages.DASHBOARD_COLLECTION_LEARN_MORE:
      return (<span>{notification.name} must add five stamps to their collection and share it before you can exchange that link for a reward</span>);
    case Messages.DASHBOARD_MESSAGE_DECLINED_LEARN_MORE:
      return (
        <div>
          <p>Your link has been declined for one of two reasons:</p>
          <p>
            <ul>
              <li>1) A user deleted their status</li>
              <li>2) A user has a private profile. Status privacy settings must be changed to Public.</li>
            </ul>
          </p>
       </div>
      );

    case Messages.WELCOME_FOLLOW_ZINES:
      return (
        <span>Follow interesting collections to fill your feed with stamps that matter to you.</span>
      );

    case Messages.FEEDBACK_SENT:
      return (<span>Thank you for your feedback.</span>);

    case Messages.EMAIL_UNSUBSCRIBE:
      return (<span>You will not receive email notifications from Stampsy.</span>);
    case Messages.EMAIL_RESUBSCRIBED:
      return (<span>You will receive email notifications from Stampsy.</span>);
    case Messages.EMAIL_UNSUBSCRIBE_ZINE:
      return (<span>You have been unsubscribed from “{notification.title}” collection.</span>);

    case Messages.INVITATION_ALREADY_USED:
      return (<span>This invitation link has expired. Please try to log in or request a new invite.</span>);
    case Messages.INVITATION_FOR_OTHER_USER:
      return (<span>This link does not work with the account you used to log in. Please, try and use another account.</span>);

    case Messages.IMAGE_ADDED_TO_GRABBAG:
      return (<span>Saved to the <Link to='draftCompose' params={{ stampSegment: 'new' }}>Editor</Link>.</span>);

    case Messages.DRAFT_FEEDBACK_SENT:
      return (<span>Your feedback was sent.</span>);

    default:
      console.warn('Unrecognized notification', notification);
    }
  },

  handleShareStampClick(stampId, service) {
    ShareActionCreators.shareStamp({
      stampId: stampId,
      service: service,
      source: AnalyticsSources.NOTIFICATION
    });
  },

  getAction(notification) {
    switch (notification.id) {
    case Messages.UNSUPPORTED_BROWSER:
      return (
        <Link to='/retrograde.htm' bold target='_blank'>
          Learn More
        </Link>
      );
    case Messages.STAMP_HAS_BEEN_SAVED:
      return (
        <Share onShareClick={this.handleShareStampClick.bind(this, notification.stampId)}
               services={[
                ServiceTypes.FACEBOOK,
                ServiceTypes.TWITTER
               ]}
               size='small'
               color='dark' />
      );
    case Messages.WELCOME_FOLLOW_ZINES:
      return (
        <Link to='zines' bold>
          View Recommended Collections
        </Link>
      );
    case Messages.USER_FIRST_EMAIL_NEEDS_CONFIRMATION:
      return (
        <div>
          <Link onClick={this.handleResendEmailClick} bold>Resend</Link>
        </div>
      );
    case Messages.USER_NEW_EMAIL_NEEDS_CONFIRMATION:
      return (
        <div>
          <Link onClick={this.handleResendEmailClick} bold>Resend</Link>
          {' or '}
          <Link onClick={this.handleCancelEmailClick} bold>Cancel</Link>
        </div>
      );
    case Messages.EMAIL_UNSUBSCRIBE:
      return (<Link onClick={this.handleResubscribeEmailClick.bind(this, notification)}>Click here to restore your subscription</Link>);
    }
  },

  handleResubscribeEmailClick(notification) {
    UserActionCreators.resubscribeEmail({
      userId: notification.userId,
      emailHash: notification.emailHash
    });
  },

  handleResendEmailClick() {
    UserActionCreators.resendUnconfirmedEmail();
  },

  handleCancelEmailClick() {
    UserActionCreators.cancelUnconfirmedEmail();
  },

  handleCloseClick(notification) {
    NotificationActionCreators.hideNotification(notification.id, notification.created);
  }
});

export default NotificationHost;



/** WEBPACK FOOTER **
 ** ./hosts/NotificationHost.jsx
 **/